// extracted by mini-css-extract-plugin
module.exports = {"popup-link-wrapper":"popup-link-wrapper___zZ_Rp","popupLinkWrapper":"popup-link-wrapper___zZ_Rp"};